import React from "react"
import PropTypes from "prop-types"

export const Property = ({ propKey, propVal, propStyle, propClass }) => {
    return (
	<span style={ propStyle }>
        <span className={ propClass }>
          <br />{ propKey }: { String(propVal) }</span></span>
    )
}
Property.propTypes = {
  propKey: PropTypes.string,
  propVal: PropTypes.any,
  propClass: PropTypes.string,
  propStyle: PropTypes.object
}

export default Property
